import {createContext, use, useRef, useState, type ReactNode, type RefObject} from 'react'
import {GearIcon} from '@primer/octicons-react'
import {SidebarSection} from '../SidebarSection'
import {SidebarDisclosureHeader} from '../SidebarDisclosureHeader'
import {ReviewerPicker} from './picker/ReviewerPicker'

const ReviewersSectionAnchorContext = createContext<RefObject<HTMLButtonElement | null> | null>(null)

export function useReviewersSectionAnchorRef() {
  return use(ReviewersSectionAnchorContext)
}

export function ReviewersSection({children}: {children: ReactNode}) {
  const [pickerOpen, setPickerOpen] = useState(false)
  const anchorRef = useRef<HTMLButtonElement>(null)

  // Full-row clickable header that anchors the picker, matching the Activity
  // section's disclosure header pattern.
  const header = (
    <SidebarDisclosureHeader
      title="Reviewers"
      trailingIcon={GearIcon}
      ref={anchorRef}
      onClick={() => setPickerOpen(!pickerOpen)}
      aria-label="Manage reviewers"
      aria-expanded={pickerOpen}
      aria-haspopup="dialog"
    />
  )

  return (
    <ReviewersSectionAnchorContext value={anchorRef}>
      <SidebarSection title="Reviewers" header={header}>
        {children}
      </SidebarSection>
      <ReviewerPicker open={pickerOpen} onOpenChange={setPickerOpen} anchorRef={anchorRef} />
    </ReviewersSectionAnchorContext>
  )
}
